import { TabPanelProps } from './TabPanel.props';

export const TabPanel = ({ active, tab, children }: TabPanelProps): JSX.Element => (
  <div role="tabpanel" hidden={active !== tab} id={`audit-tabpanel-${tab}`}>
    {active === tab && <>{children}</>}
  </div>
);
